import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import IconConstants from "../../utils/IconConstants";
import ActionOptions from "./ActionOptions";
import ExtendStay from "../extendstay/Extend-stay.jsx";
import RoomShift from "../roomshift/Room-shift.jsx";
import { END_POINT } from "../../utils/End-points.js";
import { Box, Modal, Fade, Backdrop } from "@mui/material";
import { useDispatch } from "react-redux";
import { setDashBoardData } from "../../core/store/redux/slices/Dashboard-slice.js";
import { clearReservationData } from "../../core/store/redux/slices/Reservation-slice.js";
import { clearCheckinData } from "../../core/store/redux/slices/Checkin-slice.js";
import ApiClient from "../../apis/Api-client.js";
import { useNavigate } from "react-router-dom";
import AddOrRemovePerson from "../addorremoveperson/AddOrRemovePerson.jsx";
import {
  selectTriggered,
  setTriggered,
} from "../../core/store/redux/slices/DashboardApi-slice.js";
import { useSelector } from "react-redux";
import { errorToster, successToster } from "../../shared/toster/Toster.jsx";
import MaintenanceDialog from "./MaintenanceDialog.js";
import ConfirmationDlgBox from "../common-components/confirmation-popup.jsx";
import {
  CLEANING_STATUSES,
  OCCUPANCY_STATUSES,
} from "../../utils/Constants.js";
import { useTranslation } from "react-i18next";
import { endOfDay, format, startOfDay } from "date-fns";
import { setDataToDB } from "../../db/dbHelpers.js";
import { Helper } from "../../utils/Helpers.js";
import { FEATURES, ACTIONS } from "../../core/permissions";
const { fetchAndFilterVacantRooms } = new Helper()
const { CLEAN, DIRTY, ASSIGNED } = CLEANING_STATUSES;
const CLEANING_STATUS_LABELS = {
  [DIRTY]: "Dirty",
  [ASSIGNED]: "Assigned",
};
const WARN_ON_CLEANING_STATUSES = [DIRTY, ASSIGNED];
const { CHECK_OUT, ROOM_SHIFT } = OCCUPANCY_STATUSES;

const IndividualRoomBox = ({
  item,
  searchText,
  searchFlag,
  handleResetFilters,
  selectedOccupancy,
  selectedHousekeeping,
}) => {
  const { api } = ApiClient();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = new URLSearchParams();
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [modalType, setModalType] = useState();
  const menuOpen = Boolean(anchorEl);
  const isTriggered = useSelector(selectTriggered);
  const [menuIsNearRightEdge, setMenuIsNearRightEdge] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [dirtyWarningOpen, setDirtyWarningOpen] = useState(false);
  const [pendingBookingType, setPendingBookingType] = useState(null);

  useEffect(() => {
    dispatch(clearReservationData());
    dispatch(clearCheckinData());
  }, []);

  const handleClick = (event) => {
    handleResetFilters();
    setAnchorEl(event.currentTarget);
    // Calculate if the anchor element is near the right edge of the screen
    const anchorRect = event.currentTarget.getBoundingClientRect();
    const isNearRightEdge = window.innerWidth - anchorRect.right < 100;
    setMenuIsNearRightEdge(isNearRightEdge);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const openpop = Boolean(anchorEl);
  const id = openpop ? "simple-popover" : undefined;

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleClosePopover = () => {
    setModalOpen(false);
    setAnchorEl(null);
  };

  const handleCancelModal = () => {
    setModalOpen(false);
    setAnchorEl(null);
    setModalType(null);
  };

  const renderActionModal = (modalType, data = null) => {
    setModalType(modalType);
    setModalOpen(true);
    setModalData(data);
  };

  const performBookingNavigation = (bookingType) => {
    if (bookingType === "checkOut") {
      params.append(
        "occupancy_keys",
        JSON.stringify([
          item.roomData.parent_occupancy_key ?? item.roomData.occupancy_key,
        ])
      );
      navigate(`/main/departure?${params.toString()}`);
    } else if (bookingType === "reservedCheckIn") {
      params.append("reservation_key", item.roomData.reservation_key);
      params.append("room_key", item.roomData.room_key);
      navigate(`/main/arrival/reservedcheckin?${params.toString()}`);
    } else if (bookingType === "vacantCheckIn") {
      params.append("room_key", item.roomData.room_key);
      navigate(`/main/arrival?${params.toString()}`);
    } else if (bookingType === "reserve") {
      params.append("room_key", item.roomData.room_key);
      navigate(`/main/reservation?${params.toString()}`);
    }
    handleClose();
  };

  const handleBookingNavigation = (bookingType) => {
    const isCheckInAction =
      bookingType === "vacantCheckIn" || bookingType === "reservedCheckIn";
    if (isCheckInAction && WARN_ON_CLEANING_STATUSES.includes(item.roomData?.cleaning_status_code)) {
      setPendingBookingType(bookingType);
      setDirtyWarningOpen(true);
      handleClose();
      return;
    }
    performBookingNavigation(bookingType);
  };

  const handleProceedDirtyCheckIn = () => {
    setDirtyWarningOpen(false);
    if (pendingBookingType) {
      performBookingNavigation(pendingBookingType);
      setPendingBookingType(null);
    }
  };

  const handleCancelDirtyCheckIn = () => {
    setDirtyWarningOpen(false);
    setPendingBookingType(null);
  };

  const handleGuestDetails = (route) => {
    dispatch(
      setDashBoardData({
        ...item.roomData,
        occupancy_key:
          item.roomData?.parent_occupancy_key ?? item.roomData?.occupancy_key,
      })
    );
    setTimeout(() => {
      navigate(`/main/${route}`);
    });
  };

  const handleRoomCleaning = async () => {
    setIsLoading(true);
    try {
      let changeRes = await api.put(
        END_POINT.HOUSE_KEEPING.MOVE_ROOMS_TO_DIRTY,
        {},
        item.roomData.room_id
      );
      if (changeRes.status === 200) {
        dispatch(setTriggered(!isTriggered));
        handleClosePopover();
        successToster(
          <span
            dangerouslySetInnerHTML={{
              __html: t(
                "pages.housekeeping.assign_task.alert.room_moved_to_dirty_rooms",
                { room_no: item.roomData.room_no }
              ),
            }}
          />
        );
      }
    } catch (error) {
      errorToster(t("pages.booking_form.toast.error_moving_room_to_clean"));
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    }
  };

  const handleUnderMaintenance = async (data) => {
    setIsLoading(true);
    try {
      handleClosePopover();
      const { maintenance_reason, maintenance_until } = data ?? {};
      const now = new Date();
      const maintenanceEnd = maintenance_until
        ? new Date(maintenance_until)
        : now;
      const updatedMaintenanceUntil = endOfDay(maintenanceEnd);
      const updatedMaintenanceStart = startOfDay(now);

      const isBlocked = item.roomData?.is_under_maintenance == 0;
      const res = await api.put(
        END_POINT.ROOM.UPDATE_ROOM_MAINTENANCE,
        {
          is_under_maintenance: !item.roomData?.is_under_maintenance,
          maintenance_reason: isBlocked ? maintenance_reason : null,
          maintenance_until: isBlocked
            ? format(updatedMaintenanceUntil, "yyyy-MM-dd HH:mm:ss")
            : null,
          maintenance_start: isBlocked
            ? format(updatedMaintenanceStart, "yyyy-MM-dd HH:mm:ss")
            : null,
        },
        item.roomData?.room_id
      );
      if (res?.status === 200) {
        dispatch(setTriggered(!isTriggered));
        successToster(
          <span
            dangerouslySetInnerHTML={{
              __html: t(
                !item.roomData?.is_under_maintenance
                  ? "pages.home_page.alert.blocked_success"
                  : "pages.home_page.alert.is_ready_to_occupy",
                { name: item.roomData?.room_no }
              ),
            }}
          />
        );
        const roomTypes = await api
        .get(
          `${END_POINT.ROOM.GET_ALL_ROOMS_BY_ROOMTYPE}/${format(
            new Date(),
            "yyyy-MM-dd"
          )}`
        )
        .then((res) => res?.data?.data || [])
        .catch((error) => {
          return [];
        });

      const vacantRooms = await fetchAndFilterVacantRooms(roomTypes);
      await setDataToDB("roomTypes", vacantRooms);
      }
    } catch (error) {
      errorToster(t("pages.booking_form.toast.error_moving_room_to_clean"));
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 1500);
    }
  };

  const renderRoom = () => {
    switch (item?.flag) {
      case "Vacant":
        return {
          ...item,
          doorIcon: IconConstants.VacantDoor,
          isCleanIcon: item?.image,
          cleaningStatus: item?.cleaningStatus,
          isClean: true,
          actionBtnIcn: IconConstants.ReserveWhite,
          actionBtnName: "Reserve",
          actionBtnLabel: t("pages.home_page.room_view_section.reserve"),
          actionBtnOnClick: () => {
            handleBookingNavigation("reserve");
            handleClose();
          },
          actionBtnPermFeature: FEATURES.RESERVATIONS,
          actionBtnPermAction: ACTIONS.CREATE,
          btnColor: "#62BA60",
          btnTextColor: "#FFFFFF",
          bgColor: "#DCFFDB",
          roomType: "Deluxe",
          roomData: item.roomData,
          options: [
            {
              name: "Check In",
              label: t("pages.home_page.room_view_section.check_in"),
              permFeature: FEATURES.CHECK_IN,
              permAction: ACTIONS.CREATE,
              optClick: () => {
                handleBookingNavigation("vacantCheckIn");
              },
            },
            item?.roomData?.cleaning_status_code === CLEAN
              ? {
                  name: "Move to Dirty",
                  label: t("pages.home_page.room_view_section.move_to_dirty"),
                  permFeature: FEATURES.ROOM_MANAGEMENT,
                  permAction: ACTIONS.UPDATE,
                  optClick: () => {
                    handleRoomCleaning();
                    handleClose();
                  },
                }
              : null,
            {
              label: t("pages.home_page.room_view_section.block"),
              name: "Block",
              permFeature: FEATURES.ROOM_MANAGEMENT,
              permAction: ACTIONS.BLOCK_ROOM,
              optClick: (e) => {
                renderActionModal("maintenance", item?.roomData);
              },
            },
          ],
        };
      case "Reserved":
        return {
          ...item,
          doorIcon: IconConstants.ReservedDoor,
          isCleanIcon: item?.image,
          roomData: item.roomData,
          cleaningStatus: item?.cleaningStatus,
          isClean: true,
          actionBtnIcn: IconConstants.CheckIn,
          actionBtnName: "Check In",
          actionBtnLabel: t("pages.home_page.room_view_section.check_in"),
          actionBtnOnClick: () => {
            handleBookingNavigation("reservedCheckIn");
          },
          actionBtnPermFeature: FEATURES.CHECK_IN,
          actionBtnPermAction: ACTIONS.CREATE,
          btnColor: "#FFFFFF",
          btnTextColor: "#252525",
          bgColor: "#9F70FD",
          borderColor: "#9F70FD",
          color: "#FFFFFF",
          options: [
            {
              name: "Guest Details",
              label: t("pages.home_page.room_view_section.guest_details"),
              // Not in explicit map; gated with closest view feature.
              permFeature: FEATURES.GUEST_MANAGEMENT,
              permAction: ACTIONS.VIEW,
              optClick: () => {
                handleGuestDetails("reservations");
              },
            },
            item?.roomData?.cleaning_status_code === CLEAN
              ? {
                  name: "Move to Dirty",
                  label: t("pages.home_page.room_view_section.move_to_dirty"),
                  permFeature: FEATURES.ROOM_MANAGEMENT,
                  permAction: ACTIONS.UPDATE,
                  optClick: () => {
                    handleRoomCleaning();
                    handleClose();
                  },
                }
              : null,
          ],
        };
      case "Occupied":
        return {
          ...item,
          doorIcon: IconConstants.OccupiedDoor,
          isCleanIcon: item?.image,
          roomData: item.roomData,
          cleaningStatus: item?.cleaningStatus,
          isClean: false,
          actionBtnIcn: IconConstants.CheckoutRed,
          actionBtnName: "Check Out",
          actionBtnLabel: t("pages.home_page.room_view_section.check_out"),
          actionBtnOnClick: () => {
            handleBookingNavigation("checkOut");
          },
          actionBtnPermFeature: FEATURES.CHECK_OUT,
          actionBtnPermAction: ACTIONS.CREATE,
          borderColor: "#EF7E6B",
          btnColor: "#FFFFFF",
          btnTextColor: "#EF7E6B",
          bgColor: "#FFEDEA",
          color: "#ED705B",
          options: [
            {
              name: "Guest Details",
              label: t("pages.home_page.room_view_section.guest_details"),
              // Not in explicit map; gated with closest view feature.
              permFeature: FEATURES.GUEST_MANAGEMENT,
              permAction: ACTIONS.VIEW,
              optClick: () => {
                handleGuestDetails("guestinfo/arrival");
              },
            },
            {
              name: "Room Shift",
              label: t("pages.home_page.room_view_section.room_shift"),
              permFeature: FEATURES.RESERVATIONS,
              permAction: ACTIONS.ROOM_SHIFT,
              optClick: () => {
                renderActionModal("roomShift", {
                  ...item?.roomData,
                  booking_status: item?.roomData?.occupancy_status_code,
                  room_rent: item?.roomData?.occupancy_price,
                  total_tax_rate: item?.roomData?.total_occupancy_tax_rate,
                  checkout_date: item?.roomData?.expected_checkout_date,
                  checkout_date: item?.roomData.expected_checkout_date,
                });
              },
            },
            item?.roomData?.cleaning_status_code === CLEAN
              ? {
                  name: "Move to Dirty",
                  label: t("pages.home_page.room_view_section.move_to_dirty"),
                  permFeature: FEATURES.ROOM_MANAGEMENT,
                  permAction: ACTIONS.UPDATE,
                  optClick: () => {
                    handleRoomCleaning();
                  },
                }
              : null,
          ],
        };

      case "under_maintenance":
        return {
          ...item,
          isCleanIcon: IconConstants.BlockedIcon,
          roomData: item.roomData,
          cleaningStatus: item?.cleaningStatus,
          isClean: false,
          bgColor: "#FFFFFF",
          btnColor: "#DEA829",
          btnTextColor: "#FFFFFF",
          actionBtnName: "Ready to occupy",
          actionBtnLabel: t(
            "pages.home_page.room_view_section.ready_to_occupy"
          ),
          actionBtnOnClick: () => {
            handleUnderMaintenance();
          },
          actionBtnPermFeature: FEATURES.ROOM_MANAGEMENT,
          actionBtnPermAction: ACTIONS.UNBLOCK_ROOM,
        };
      default:
        return {
          ...item,
        };
    }
  };
  let room = renderRoom();

  const handleOpenPersonPopover = (name) => {
    setModalType(name);
    setModalOpen(true);
  };

  return (
    <>
      <Grid
        item
        sx={{
          width: { xs: "15.38vw", sm: "9.59vw", md: "5.56vw" },
          height: { xs: "10.8vw", sm: "7.19vw", md: "4.17vw" },
          cursor: "pointer",
          transition: "all 0.3s ease",
          border: item?.border,
          borderRadius: { xs: "6px", sm: "0.96vw", md: "0.56vw" },
          backgroundColor:
            (!item.isAllSelected && item.isSelected) || id
              ? item.filteredBackgroundColor
              : item.backgroundColor,
          filter:
            item.isSelected ||
            item.isAllSelected ||
            (searchFlag && item.roomNo === searchText)
              ? ""
              : "blur(3px)",
          opacity:
            item.isSelected ||
            item.isAllSelected ||
            (searchFlag && item.roomNo === searchText)
              ? 1
              : 0.9,
        }}
        id="action-room-button"
        aria-controls={menuOpen ? "action-room-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={menuOpen ? "true" : undefined}
        onClick={(event) =>
          item.isSelected ||
          item.isAllSelected ||
          (searchFlag && item.roomNo === searchText)
            ? handleClick(event)
            : ""
        }
      >
        <Box
          sx={{
            width: "85%",
            height: "100%",
            margin: "3% auto",
            // display: (!item.isSelected && !!room.roomData.name) ? "block" : "flex",
            display:
              item?.houseKeepId == item.roomData.cleaning_status_id ||
              ![CHECK_OUT, ROOM_SHIFT].includes(
                room.roomData?.occupancy_status_code
              ) ||
              room.roomData?.reservation_status_code ||
              room.roomData.is_under_maintenance == 1 ||
              (selectedOccupancy && selectedHousekeeping)
                ? "block"
                : "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {(item.isSelected && (!!item?.houseKeepId || !!item?.todaysFilter)) ||
          (selectedOccupancy && selectedHousekeeping) ||
          room.roomData.is_under_maintenance == 1 ? (
            <Box
              sx={{ marginBottom: { md: "5%" }, transition: "all 0.2s ease" }}
            >
              <Box
                sx={{
                  height:
                    room.roomData.is_under_maintenance == 1
                      ? { xs: "5.13vw", sm: "2.9vw", md: "1.65vw" }
                      : { xs: "5.13vw", sm: "3.36vw", md: "1.94vw" },
                  width:
                    room.roomData.is_under_maintenance == 1
                      ? { xs: "5.13vw", sm: "2.95vw", md: "1.73vw" }
                      : { xs: "5.13vw", sm: "3.36vw", md: "1.94vw" },
                }}
              >
                <img
                  src={
                    room.roomData.is_under_maintenance == 1 &&
                    (item.isSelected || id)
                      ? item.roomStatusIcon
                      : item?.image
                  }
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                />
              </Box>
            </Box>
          ) : (
            (![CHECK_OUT, ROOM_SHIFT].includes(
              room.roomData?.occupancy_status_code
            ) ||
              room.roomData?.reservation_status_code) &&
            room.roomData.is_under_maintenance == 0 && (
              <Box
                sx={{
                  marginBottom: { xs: "10%", md: "15%" },
                  transition: "all 0.2s ease",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "2.56vw", sm: "1.44vw", md: "0.83vw" },
                    color: item.isSelected || id ? "#FFFFFF" : item?.nameColor,
                    fontWeight: 500,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {room.roomData?.name}
                </Typography>
              </Box>
            )
          )}
          <Typography
            sx={{
              textAlign: "right",
              fontWeight: 700,
              color:
                (item.isSelected &&
                  (!selectedOccupancy || !selectedHousekeeping) &&
                  !item?.houseKeepId &&
                  !item?.todaysFilter) ||
                id
                  ? "#FFFFFF"
                  : item?.color,
              fontSize: { xs: "3.08vw", sm: "2.4vw", md: "1.12vw" },
            }}
          >
            {item?.roomNo}
          </Typography>
        </Box>
      </Grid>
      <ActionOptions
        anchorEl={anchorEl}
        menuOpen={menuOpen}
        handleClose={handleClose}
        room={room}
        handleOpenPersonPopover={handleOpenPersonPopover}
        modalName={modalType}
        menuIsNearRightEdge={menuIsNearRightEdge}
        isLoading={isLoading}
      />
      <Modal
        open={modalOpen}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={modalOpen}>
          <Box
            sx={{
              borderRadius: "16px",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              padding: { xs: "4%", sm: "2.5%", md: "1.5%" },
              minWidth: { xs: "90%", sm: 0 },
            }}
          >
            {modalType === "extendStay" && (
              <ExtendStay
                bookingData={modalData}
                handleCloseModal={handleCloseModal}
                handleClosePopover={handleClosePopover}
              />
            )}
            {modalType === "roomShift" && (
              <RoomShift
                bookingData={modalData}
                handleCloseModal={handleCloseModal}
                handleClosePopover={handleClosePopover}
              />
            )}
            {modalType === "maintenance" && (
              <MaintenanceDialog
                handleCloseModal={handleCancelModal}
                modalFunction={(data) => handleUnderMaintenance(data)}
                isLoading={isLoading}
                reservedDate={item?.roomData.checkin_date}
              />
            )}
            {(modalType === "Remove Person" || modalType === "Add Person") && (
              <AddOrRemovePerson
                modalName={modalType}
                handleClose={handleCancelModal}
                data={room?.roomData}
              />
            )}
          </Box>
        </Fade>
      </Modal>
      <ConfirmationDlgBox
        open={dirtyWarningOpen}
        label={`Room ${item.roomData?.room_no} is ${CLEANING_STATUS_LABELS[item.roomData?.cleaning_status_code] || "Dirty"}. Do you want to proceed?`}
        confirmFunction={handleProceedDirtyCheckIn}
        cancelFunction={handleCancelDirtyCheckIn}
        setOpen={setDirtyWarningOpen}
        confirmLabel="Proceed"
        cancelLabel="Go Back"
      />
    </>
  );
};
export default IndividualRoomBox;
